
export class Building {

    // _id: string
    id : string
    market : string
    morphology : string
    useCategory? : string
    category? : string
    characteristics? : string
    commonName? : string
    civicAddress? : string
    civicLatitude? : number
    civicLongitude? : number
    contactName? : string
    contactNumber? : string
    contactEmail? : string
    construction? : string
    updatedAt?: number
    deleted?: boolean
    _rev?: string
}